<app-confirmed-offer />
